import React from 'react';
import Button from '../shared/Button';
import { LogoWrapper, Logo } from './PartnerLearnFinancing.styles';
import { Heading, FinancingDescription, ButtonWrapper } from '../shared/Financing.styles';
import { KissMetrics } from '../../../shared/services';
import {
  CAPITAL_ONE_TITLE,
  PARTNER_LENDING_TITLE,
  CAPITAL_ONE_PARTNER_ID,
  PARTNER_LENDING_ID,
  PARTNER_LOGO_ASSET_FOLDER,
  CAPITAL_ONE_DESCRIPTION,
  PARTNER_LENDING_DESCRIPTION,
  PARTNER_FINANCING_DESCRIPTION,
  PARTNER_FINANCING_TITLE
} from '../constants';

const getHeaderAndDescription = (partnerId: number, partnerLongName: string) => {
  const isCapitalOnePartner = partnerId === CAPITAL_ONE_PARTNER_ID;
  const isPartnerLending = partnerId === PARTNER_LENDING_ID;
  if (isCapitalOnePartner) {
    return { header: CAPITAL_ONE_TITLE, description: CAPITAL_ONE_DESCRIPTION };
  }
  if (isPartnerLending) {
    return { header: PARTNER_LENDING_TITLE, description: PARTNER_LENDING_DESCRIPTION };
  }
  return {
    header: PARTNER_FINANCING_TITLE(partnerLongName),
    description: PARTNER_FINANCING_DESCRIPTION(partnerLongName)
  };
};

type OwnProps = {
  partnerId: number;
  partnerLongName: string;
  partnerVanityUrlName: string;
};

export default function PartnerLearnFinancing({
  partnerLongName,
  partnerVanityUrlName,
  partnerId
}: OwnProps) {
  const isPartnerLending = partnerId === PARTNER_LENDING_ID;
  const { header, description } = getHeaderAndDescription(partnerId, partnerLongName);

  return (
    <>
      <Heading>{header}</Heading>
      <FinancingDescription>{description}</FinancingDescription>
      {!isPartnerLending && (
        <LogoWrapper>
          <Logo src={`${PARTNER_LOGO_ASSET_FOLDER}/${partnerVanityUrlName.toLowerCase()}.png`} />
        </LogoWrapper>
      )}
      <ButtonWrapper>
        <Button
          href="/learn-financing"
          onClick={() => KissMetrics.trackEvent('Account - Finance - Clicked Learn More')}
        >
          Learn More
        </Button>
      </ButtonWrapper>
    </>
  );
}
